module.exports = __webpack_public_path__ + "img/hs_diplomma.3f513c9f.jpg";